/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Icon } from '@firesoon/antd';
import React from 'react';
import { CURRENT_YEAR, FORMATQUARTERS, QUARTERS } from '../constants';
import { QuarterPickerProps, QuarterPickerState } from '../interface';

import './index.less';

const YEAR = CURRENT_YEAR.get('year');

class QuarterPicker extends React.Component<QuarterPickerProps, QuarterPickerState> {
  static defaultProps = {
    quarters: QUARTERS,
    formatQuarters: FORMATQUARTERS,
    year: null,
    quarter: null,
    yearSuffix: '年',
    onChange: () => {},
    disableFuture: true,
    className: '',
    placeholder: '请选择季度',
    startYear: null,
  };

  constructor(props: any) {
    super(props);
    this.state = {
      show: false,
      year: props.year,
      quarter: Number(props.quarter),
      optYear: props.year ? Number(props.year) : CURRENT_YEAR.get('year'),
    };
  }

  // 点击日期框,弹出或隐藏日期选择框
  showPanel = () => {
    this.setState({
      show: !this.state.show,
    });
  };

  // 切换年份
  changeYear = (type) => {
    const { optYear, quarter } = this.state;
    const { type: quarterType, limit } = this.props;

    let quarterIndex = quarter;
    let date = optYear;
    let nowMonth = new Date().getMonth();

    // 如果传入limit，则为季度联选
    if (limit) {
      const { year: limitYear } = limit;
      if (quarterType === 'start') {
        // 开始
        if (type === '+') {
          if (date < YEAR && date < limitYear) {
            date = date + 1;
          }
        } else {
          if (date > 0) {
            date = date - 1;
          }
        }
      } else {
        // 结束框
        if (type === '+') {
          if (date < YEAR) {
            date = date + 1;
          }
        } else {
          if (date > 0 && date > limitYear) {
            date = date - 1;
          }
        }
      }

      // 临界： 年份相同时，如果季度不合理，设置合适的季度
      if (date === limitYear) {
        // 当前季度被disabled（limit）
        const limitIndex = limit.quarter;
        if (quarterType === 'start') {
          quarterIndex = Math.min(limitIndex, quarterIndex);
        } else {
          quarterIndex = Math.max(limitIndex, quarterIndex);
        }
      }
    } else {
      // 普通的季度选择框
      if (type === '+') {
        if (date < YEAR) {
          date = date + 1;
        }
      } else {
        if (date > 0) {
          date = date - 1;
        }
      }
    }

    // 如果当前年份和被选中年份相同,则需要判断当前被选中季度是否可被选中,如果不行,则自动调整到当年第一季度
    if (date === YEAR) {
      const current = Math.floor(nowMonth / 3);
      if (quarterIndex > current) {
        quarterIndex = 0; // quarterIndex = current为自动调整到当前季度，考虑季度联选，limit问题，不采取次措施
      }
    }
    this.setState({
      year: date,
      quarter: quarterIndex,
      optYear: date,
    });
  };

  // 获取季度
  getQuarterArray = (select) => {
    const array = [] as Array<any>;
    const nowMonth = new Date().getMonth();
    const { year, optYear } = this.state;
    const { quarters } = this.props;
    const { limit, type } = this.props;
    let classStyle;
    let flag = 1;
    let style;

    if (quarters == null) {
      return [];
    }

    for (let i = 0; i < quarters.length; i++) {
      flag = 1;
      if (optYear === YEAR && i * 3 > nowMonth) {
        // 判断当前季度能不能被选择
        flag = 0;
      }
      // 当前季度可选，再判断 联选季度
      if (flag && limit) {
        const { year: limitedYear, quarter: limitedQuarter } = limit;
        const limitedQuarterIndex = limitedQuarter;
        if (year === limitedYear) {
          // 只有年份相等时处理季度选择问题
          if (type === 'start') {
            flag = i > limitedQuarterIndex ? 0 : 1;
          } else if (type === 'end') {
            flag = i < limitedQuarterIndex ? 0 : 1;
            // style清空
            style = {};
          }
        }
      }

      if (flag === 1) {
        classStyle = select === i ? 'fs-select-dropdown-menu-item active' : 'fs-select-dropdown-menu-item';
      } else {
        classStyle = 'fs-select-dropdown-menu-item disable';
      }

      array.push(
        <li
          key={quarters[i]}
          className={classStyle}
          onClick={flag ? this.select.bind(null, i) : () => {}}
          style={style}
          title={`${year ?? optYear}年${quarters[i]}`}
        >
          {quarters[i]}
        </li>,
      );
    }

    return array;
  };

  /**
   * 选择季度
   */
  select = (quarter) => {
    const { optYear } = this.state;
    this.setState({
      quarter,
      year: optYear,
    });
    this.hideSelect();
  };

  // 设置默认时间
  getDefaultDate = () => {
    const { year, quarter } = this.state;
    const { formatQuarters, placeholder, yearSuffix } = this.props;
    const noData = year == null || quarter == null;

    let date = `${year}${yearSuffix}${formatQuarters == null ? '' : formatQuarters[quarter]}`;

    if (noData) {
      date = placeholder ?? '';
    }

    return (
      <div
        className={`box ant-select-selection ${noData ? 'noData' : ''}`}
        onClick={this.showPanel}
        data-type="box"
        tabIndex={0}
      >
        {date}
        <Icon type="calendar" />
      </div>
    );
  };

  /**
   * 隐藏选择框
   */
  hideSelect = () => {
    this.setState(
      {
        show: false,
      },
      this.getDate,
    );

    // 当点击非操作区相当于确定当前选择
    if (typeof this.props.handleOk === 'function') {
      this.props.handleOk();
    }
  };

  /**
   * 将被选择的时间传递给发起者
   */
  getDate = () => {
    const { onChange, year, quarter } = this.props;
    const po = {
      year: this.state.year,
      quarter: this.state.quarter,
    };

    if ((year !== this.state.year || quarter !== this.state.quarter) && onChange) {
      onChange(po);
    }
  };

  render() {
    const { quarter, show, optYear } = this.state;
    const { yearSuffix, disableFuture, className, startYear } = this.props;
    const defaultDate = this.getDefaultDate();
    const quarterStartArray = this.getQuarterArray(quarter);
    const disableNext = optYear === YEAR && disableFuture;
    const disablePre = startYear != null && optYear <= startYear;

    return (
      <div className={`fs-quarterPicker ${className}`}>
        <div className="fs-month-picker">
          {defaultDate}

          <div className="container table show" style={{ display: show ? '' : 'none', position: 'absolute', top: 34 }}>
            <div className="overlay" onClick={this.hideSelect} />

            <div className="cell">
              <div className="popup range show">
                <div className="pad">
                  <div className="clearfix labelContent">
                    <Icon
                      title="上一年"
                      type="double-left"
                      className={`tab ${disablePre ? 'disabled' : ''}`}
                      onClick={() => {
                        if (disablePre) {
                          return;
                        }
                        this.changeYear('-');
                      }}
                    />
                    <div className="label" data-type="label">
                      {optYear}
                      {yearSuffix}
                    </div>
                    <Icon
                      title={disableNext ? '' : '下一年'}
                      className={`tab ${disableNext ? 'disabled' : ''}`}
                      type="double-right"
                      onClick={() => {
                        if (disableNext) {
                          return;
                        }
                        this.changeYear('+');
                      }}
                    />
                  </div>
                  <ul>{quarterStartArray}</ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default QuarterPicker;
